import { Check } from "lucide-react";
import creditBuildingRamp400 from "@/assets/credit-building-ramp-400.jpg";
import creditBuildingRamp800 from "@/assets/credit-building-ramp-800.jpg";

const bullets = [
  "No credit check required to join",
  "Credit builder included — no extra cost",
  "Turn everyday payments into credit-building progress",
  "Track your progress over time",
  "Unlock better rates on cars, apartments, and loans",
];

const CreditSuperpower = () => {
  return (
    <section
      className="w-full py-16 lg:py-24 border-t"
      style={{ backgroundColor: '#1a1a1a', borderColor: 'rgba(255,255,255,0.08)' }}
    >
      <div className="container mx-auto px-4" style={{ maxWidth: '1200px' }}>
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

          {/* Left: Image */}
          <div className="w-full lg:w-1/2 flex-shrink-0">
            <img
              src={creditBuildingRamp800}
              srcSet={`${creditBuildingRamp400} 400w, ${creditBuildingRamp800} 800w`}
              sizes="(max-width: 1024px) 100vw, 50vw"
              alt="Credit building progress illustration"
              className="w-full rounded-2xl object-cover"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Right: Text */}
          <div className="w-full lg:w-1/2">
            <h2
              className="text-white font-bold mb-6"
              style={{
                fontSize: 'clamp(32px, 4vw, 58px)',
                lineHeight: 1.1,
                letterSpacing: '-0.04em',
              }}
            >
              Your phone bill is now your superpower.
            </h2>
            <p
              className="mb-8"
              style={{
                color: 'rgba(255,255,255,0.65)',
                fontSize: 'clamp(15px, 1.5vw, 18px)',
                lineHeight: 1.7,
              }}
            >
              For too long, the financial system has locked out young builders. We changed the rules. Perch gives you the tools to turn everyday payments into real credit progress.
            </p>
            <ul className="space-y-4">
              {bullets.map((bullet) => (
                <li key={bullet} className="flex items-start gap-3">
                  <Check
                    className="w-5 h-5 flex-shrink-0 mt-0.5"
                    style={{ color: '#B0F18D' }}
                  />
                  <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: '15px', lineHeight: 1.6 }}>
                    {bullet}
                  </span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CreditSuperpower;
